import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import {
    Box, Button, Collapse, FormControl, IconButton, InputLabel, MenuItem,
    Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    TextField, Typography, Menu, ListItemIcon, ListItemText, Pagination, Checkbox
  } from '@mui/material';
import { ExpandMore, ExpandLess, Search, History, MoreVert, Add, Edit } from '@mui/icons-material';
import Navbar from '../Layouts/Navbar';
import Snackbar from '@mui/material/Snackbar';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import MuiAlert from '@mui/material/Alert';
import HistoriqueModal from './HistoriqueModal';
import DeleteIcon from '@mui/icons-material/Delete';
import AddModal from './AddModal';
import UpdateModal from './UpdateModal';



export default function SiteTable() {
  const [openhis, setOpenHis] = useState(false);
  const handleOpenHis = () => setOpenHis(true);
  const handleCloseHis = () => setOpenHis(false);

  const [openadd, setOpenAdd] = useState(false);
  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  const [openupd, setOpenUpd] = useState(false);
  const handleOpenUpd = () => setOpenUpd(true);
  const handleCloseUpd = () => setOpenUpd(false);
  
  const [selectedSite, setSelectedSite] = useState(null);




  const [snack, setSnack] = useState({ open: false, message: '', type: 'success' });
  const handleSnack = (message, type = 'success') => {
    setSnack({ open: true, message, type });
  };
  
  const handleCloseSnack = (event, reason) => {
    if (reason === 'clickaway') return;
    setSnack({ ...snack, open: false });
  };

  const [open, setOpen] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [menuRowId, setMenuRowId] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(1);
  
  // State for selected rows/checkboxes
  const [selected, setSelected] = useState([]);
  const [groupAction, setGroupAction] = useState('');
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [societes, setSocietes] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchSociete, setSearchSociete] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  
  // Fetch sites data
  useEffect(() => {
    fetchSites();
    fetchSocietes();
  }, []);
  
  const fetchSites = async () => {
    setLoading(true);
    try {
      const response = await api.get('/sites');
      setRows(response.data.map(site => ({
        id: site.ID_Site,
        nom: site.name,
        societe: site.societe ? site.societe.name : '',
        societeId: site.ID_Societe,
        latitude: site.latitude || '',
        longitude: site.longitude || '',
        statut: site.Status || 'Active'
      })));
    } catch (error) {
      console.error('Error fetching sites:', error);
      
      // Handle server errors (500)
      if (error.response && error.response.status === 500) {
        const errorMessage = error.response.data.message || "Une erreur serveur s'est produite lors du chargement des sites";
        handleSnack(errorMessage, 'error');
      }
      // Handle network errors or other issues
      else {
        handleSnack("Erreur de connexion au serveur. Veuillez réessayer plus tard.", 'error');
      }
    } finally {
      setLoading(false);
    }
  };
  
  const fetchSocietes = async () => {
    try {
      const response = await api.get('/societes');
      setSocietes(response.data || []);
    } catch (error) {
      console.error('Error fetching societes:', error);
    }
  };
  

  const handleDelete = async () => {
    try {
      if (!menuRowId) return;
      
      await api.delete(`/sites/${menuRowId}`);
      fetchSites(); // Refresh the list
      handleSnack('Site supprimé avec succès', 'success');
      handleMenuClose();
    } catch (error) {
      console.error('Error deleting site:', error);
      
      // Handle validation errors (422)
      if (error.response && error.response.status === 422) {
        const errorMessage = error.response.data.message || "Erreur de validation lors de la suppression du site";
        handleSnack(errorMessage, 'error');
      }
      // Handle server errors (500)
      else if (error.response && error.response.status === 500) {
        const errorMessage = error.response.data.message || "Une erreur serveur s'est produite lors de la suppression du site";
        handleSnack(errorMessage, 'error');
      }
      // Handle network errors or other issues
      else {
        handleSnack("Erreur de connexion au serveur. Veuillez réessayer plus tard.", 'error');
      }
    }
  };

  const handleModify = () => {
    handleOpenUpd();
    handleMenuClose();
  };
  
  const handleToggleStatus = async (siteId, currentStatus) => {
    try {
      // Toggle the status value
      const newStatus = currentStatus === 'Active' ? 'Inactive' : 'Active';
      
      // Send PATCH request to update just the status
      await api.patch(`/sites/${siteId}`, { Status: newStatus });
      
      // Refresh the sites list
      fetchSites();
      handleSnack(`Statut du site modifié avec succès`, 'success');
    } catch (error) {
      console.error('Error toggling site status:', error);
      
      // Handle validation errors (422)
      if (error.response && error.response.status === 422) {
        const serverErrors = error.response.data.errors;
        
        // Check if there's a specific validation error for the Status field
        if (serverErrors && serverErrors.Status) {
          handleSnack(serverErrors.Status[0], 'error');
        } else {
          const errorMessage = error.response.data.message || "Erreur de validation lors de la modification du statut";
          handleSnack(errorMessage, 'error');
        }
      }
      // Handle validation errors (400)
      else if (error.response && error.response.status === 400) {
        const serverErrors = error.response.data;
        
        // Check if there's a specific validation error for the Status field
        if (serverErrors && serverErrors.Status) {
          handleSnack(serverErrors.Status[0], 'error');
        } else {
          const errorMessage = "Erreur de validation lors de la modification du statut";
          handleSnack(errorMessage, 'error');
        }
      }
      // Handle server errors (500)
      else if (error.response && error.response.status === 500) {
        const errorMessage = error.response.data.message || "Une erreur serveur s'est produite lors de la modification du statut";
        handleSnack(errorMessage, 'error');
      }
      // Handle network errors or other issues
      else {
        handleSnack("Erreur de connexion au serveur. Veuillez réessayer plus tard.", 'error');
      }
    }
  };

  const handleMenuClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(id);
    const site = rows.find(row => row.id === id);
    if (site) {
      setSelectedSite(site);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(1);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map(n => n.id);
      setSelected(newSelected);
    } else {
      setSelected([]);
    }
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    
    setSelected(newSelected);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  const handleGroupAction = async () => {
    if (groupAction === 'Supprimer' && selected.length > 0) {
      try {
        // Delete multiple sites
        await Promise.all(selected.map(id => api.delete(`/sites/${id}`)));
        fetchSites(); // Refresh the list
        handleSnack('Sites supprimés avec succès', 'success');
        setSelected([]);
        setGroupAction('');
      } catch (error) {
        console.error('Error deleting sites:', error);
        
        // Handle validation errors (422)
        if (error.response && error.response.status === 422) {
          const errorMessage = error.response.data.message || "Erreur de validation lors de la suppression des sites";
          handleSnack(errorMessage, 'error');
        }
        // Handle server errors (500)
        else if (error.response && error.response.status === 500) {
          const errorMessage = error.response.data.message || "Une erreur serveur s'est produite lors de la suppression des sites";
          handleSnack(errorMessage, 'error');
        }
        // Handle network errors or other issues
        else {
          handleSnack("Erreur de connexion au serveur. Veuillez réessayer plus tard.", 'error');
        }
      }
    }
  };
  
  // Search functionality
  const handleSearch = () => {
    fetchSites();
  };
  
  const handleReset = () => {
    setSearchKeyword('');
    setSearchSociete('');
    setSearchStatus('');
    fetchSites();
  };

  // Filter rows based on search criteria
  const filteredRows = rows.filter(row => {
    const matchesKeyword = searchKeyword ? 
      row.nom.toLowerCase().includes(searchKeyword.toLowerCase()) : true;
    
    const matchesSociete = searchSociete ? 
      row.societeId === searchSociete : true;
    
    const matchesStatus = searchStatus ? 
      row.statut === searchStatus : true;
    
    return matchesKeyword && matchesSociete && matchesStatus;
  });
  
  const paginatedRows = filteredRows.slice((page - 1) * rowsPerPage, page * rowsPerPage);
  const pageCount = Math.ceil(filteredRows.length / rowsPerPage);

  return (
    <Box>
      <Navbar />
      <Box p={2}>
        {/* Header */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <LocationCityIcon />
            <Typography variant="h6">SITES</Typography>
          </Box>
          <Box display="flex" gap={2}>
            <Button variant="outlined"
             onClick={handleOpenAdd}
            sx={{
              color: 'red',
              borderColor: 'red',
              textTransform: 'none',
              '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
            }} startIcon={<Add />}>Ajouter</Button>
          </Box>
        </Box>
          {/* Search Section */}
          <Paper variant="outlined" sx={{ mb: 3 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1} mt={1} onClick={() => setOpen(!open)} sx={{ cursor: 'pointer' }}>
            <Search />
            <Typography variant="h6" sx={{ flexGrow: 1 }}>RECHERCHER</Typography>
            <IconButton>{open ? <ExpandLess /> : <ExpandMore />}</IconButton>
          </Box>
        </Paper>

        <Collapse in={open}>
          <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
            <Box display="flex" gap={2} mb={2}>
            <TextField
                label="Mot cle"
                InputLabelProps={{ shrink: true }}
                fullWidth size="small"
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  },
                  '& .MuiInputLabel-root': {
                    '&.Mui-focused': { color: 'red' },
                    '&:hover': { color: '#000' },
                  }
                }}
              />
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Société</InputLabel>
                <Select 
                  label="Société"
                  value={searchSociete}
                  onChange={(e) => setSearchSociete(e.target.value)}
                >
                  <MenuItem value="">Toutes les sociétés</MenuItem>
                  {societes.map(societe => (
                    <MenuItem key={societe.ID_Societe} value={societe.ID_Societe}>
                      {societe.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth size="small" sx={{
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
                <InputLabel sx={{
                  '&.Mui-focused': { color: 'red' },
                  '&:hover': { color: '#000' },
                }}>Statut</InputLabel>
                <Select 
                  label="Statut"
                  value={searchStatus}
                  onChange={(e) => setSearchStatus(e.target.value)}
                >
                  <MenuItem value="">Tous les statuts</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Désactivé">Désactivé</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box display="flex" justifyContent="space-between" gap={2}>
              <Button 
                variant="outlined" 
                onClick={handleReset}
                sx={{
                  color: 'red',
                  borderColor: 'red',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                }}
              >
                Reset
              </Button>
              <Button 
                variant="outlined" 
                onClick={handleSearch}
                sx={{
                  color: 'red',
                  borderColor: 'red',
                  textTransform: 'none',
                  '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
                }}
              >
                Search
              </Button>
            </Box>
          </Paper>
        </Collapse>


        {/* Bulk Actions */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center" gap={2}>
            <Typography>Actions groupées</Typography>
            <FormControl size="small" sx={{
                minWidth: 150 ,
                '& .MuiOutlinedInput-root': {
                  '&:hover fieldset': { borderColor: '#000' },
                  '&.Mui-focused fieldset': { borderColor: 'red' },
                }
              }}>
              <Select
                value={groupAction}
                onChange={(e) => setGroupAction(e.target.value)}
                displayEmpty
              >
                <MenuItem value="" disabled><em>Sélectionner</em></MenuItem>
                <MenuItem value="Supprimer">Supprimer</MenuItem>
              </Select>
            </FormControl>
            <Button
              variant="contained"
              disabled={!groupAction || selected.length === 0}
              onClick={handleGroupAction}
              sx={{
                bgcolor: 'red',
                textTransform: 'none',
                '&:hover': { bgcolor: 'red' },
                '&.Mui-disabled': { bgcolor: '#f5f5f5', color: '#bdbdbd' }
              }}
            >
              Appliquer
            </Button>
          </Box>
          <Typography>{selected.length} sélectionnés / {rows.length} entrées</Typography>
        </Box>

        {/* Table */}
        <TableContainer component={Paper} variant="outlined">
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={selected.length > 0 && selected.length < rows.length}
                        checked={rows.length > 0 && selected.length === rows.length}
                        onChange={handleSelectAll}
                        sx={{
                        '&.MuiCheckbox-indeterminate': { color: '#000' },
                        '&.Mui-checked': { color: '#000' },
                        }}
                    />
                    </TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Nom</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Societé</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Latitude</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Longitude</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Statut</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Actions</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {paginatedRows.map((row) => {
                    const isItemSelected = isSelected(row.id);
                    return (
                    <TableRow key={row.id} hover selected={isItemSelected}>
                        <TableCell padding="checkbox">
                        <Checkbox
                            checked={isItemSelected}
                            onChange={(event) => handleSelectOne(event, row.id)}
                            sx={{
                            '&.MuiCheckbox-indeterminate': { color: '#000' },
                            '&.Mui-checked': { color: '#000' },
                            }}
                        />
                        </TableCell>
                        <TableCell>{row.nom}</TableCell>
                        <TableCell>{row.societe}</TableCell>
                        <TableCell>{row.latitude}</TableCell>
                        <TableCell>{row.longitude}</TableCell>
                        <TableCell>
                        <Box
                            sx={{
                            backgroundColor: row.statut === 'Actif' || row.statut === 'Active' ? '#4caf50' : '#dc3545',
                            color: 'white',
                            borderRadius: '4px',
                            px: 1,
                            py: 0.5,
                            display: 'inline-block',
                            fontSize: '0.8rem',
                            textAlign: 'center',
                            minWidth: '60px',
                            cursor: 'pointer',
                            '&:hover': {
                              opacity: 0.8,
                            }
                            }}
                            onClick={() => handleToggleStatus(row.id, row.statut)}
                        >
                            {row.statut}
                        </Box>
                        </TableCell>
                        <TableCell>
                        <IconButton onClick={(e) => handleMenuClick(e, row.id)}>
                            <MoreVert />
                        </IconButton>
                        <Menu
                            anchorEl={anchorEl}
                            open={menuRowId === row.id && openMenu}
                            onClose={handleMenuClose}
                            PaperProps={{
                            sx: {
                                minWidth: '200px',
                                '& .MuiMenuItem-root': {
                                color: 'black',
                                '& .MuiListItemIcon-root': { color: 'black' },
                                '&:hover': {
                                    backgroundColor: 'red',
                                    color: 'white',
                                    '& .MuiListItemIcon-root': { color: 'white' },
                                },
                                },
                            },
                            }}
                        >
                            <MenuItem onClick={handleModify}>
                            <ListItemIcon><Edit fontSize="small" /></ListItemIcon>
                            <ListItemText>Modifier</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} onClick={handleOpenHis}>
                            <ListItemIcon sx={{ color: 'red' }}><History fontSize="small" /></ListItemIcon>
                            <ListItemText>Historique</ListItemText>
                            </MenuItem>
                            <MenuItem sx={{ color: 'red' }} onClick={handleDelete}>
                            <ListItemIcon sx={{ color: 'red' }}><DeleteIcon fontSize="small" /></ListItemIcon>
                            <ListItemText>Supprimer</ListItemText>
                            </MenuItem>
                        </Menu>
                        </TableCell>
                    </TableRow>
                    );
                })}
                </TableBody>
            </Table>
        </TableContainer>

        {/* Pagination */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Typography>{rows.length} entrées</Typography>
          <Box display="flex" gap={2} alignItems="center">
            <FormControl size="small" sx={{
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': { borderColor: '#000' },
                '&.Mui-focused fieldset': { borderColor: 'red' },
              }
            }}>
              <Select value={rowsPerPage} onChange={handleChangeRowsPerPage}>
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </FormControl>
            <Pagination
              count={pageCount}
              page={page}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
            />
          </Box>
        </Box>
      </Box>

      <Snackbar 
        open={snack.open} 
        autoHideDuration={3000} 
        onClose={handleCloseSnack} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert 
          onClose={handleCloseSnack} 
          severity={snack.type} 
          elevation={6} 
          variant="filled" 
          sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>

    <HistoriqueModal open={openhis} handleClose={handleCloseHis} />
    <AddModal 
      open={openadd} 
      handleClose={handleCloseAdd} 
      handleSnack={handleSnack}
      onSuccess={fetchSites}
    />
    <UpdateModal 
      open={openupd} 
      handleClose={handleCloseUpd} 
      handleSnack={handleSnack}
      selectedRow={selectedSite}
      onSuccess={fetchSites}
    />
    </Box>
  );
}